<form>
  <div class="coordinates">
    <mat-form-field appearance="outline">
      <mat-label>X</mat-label>
      <input
        name="x"
        matInput
        [ngModel]="x"
        (ngModelChange)="updateStore($event, 0)"
        type="number"
        step="0.01"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Y</mat-label>
      <input
        name="y"
        matInput
        [ngModel]="y"
        (ngModelChange)="updateStore($event, 1)"
        type="number"
        step="0.01"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Z</mat-label>
      <input
        name="z"
        matInput
        [ngModel]="z"
        (ngModelChange)="updateStore($event, 2)"
        type="number"
        step="0.01"
      />
    </mat-form-field>
  </div>
</form>
